import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FrontendLoggerService } from './frontend-logger.service';
import type { PenaltyQuestionsConfig, PenaltyConfigItem } from "../models/rag/penalty-question-config";
import { ApiService } from './api.service';

interface RerankConfigItemDto {
  key: string;
  value: number;
}

@Injectable({
  providedIn: "root",
})
export class RagService {
  constructor(private apiService: ApiService, private frontendLogger: FrontendLoggerService) {}

  // Obtener estado del sistema
  getStatus(): Observable<any> {
    // Llama al endpoint de estado del servicio RAG: /api/rag/status
    this.frontendLogger.info('Solicitando estado del sistema RAG', 'RagService.getStatus');
    return this.apiService.get<any>('rag/status');
  }
  // Configuración avanzada de penalización de preguntas
  getPenaltyQuestionsConfig(): Observable<PenaltyConfigItem[]> {
    this.frontendLogger.info('Obteniendo configuración de penalización de preguntas', 'RagService.getPenaltyQuestionsConfig');
    return this.apiService.get<PenaltyConfigItem[]>('rag/rerank-config');
  }

  updatePenaltyQuestionsConfig(config: PenaltyQuestionsConfig): Observable<void> {
    this.frontendLogger.info('Actualizando configuración de penalización de preguntas', 'RagService.updatePenaltyQuestionsConfig');
    const payload: RerankConfigItemDto[] = [
      { key: 'tfidf_min', value: config.enabled ? config.tfidfMin : 0 },
      { key: 'embedding_min', value: config.enabled ? config.embeddingMin : 0 },
      { key: 'tfidf_penalty', value: config.enabled ? config.tfidfPenalty : 0 }
    ];
    return this.apiService.put<void>('rag/rerank-config', payload);
  }
}


